import React from "react";

function FullScreenLoader({ text = "Loading" }) {
  return (
    <div className="loader-overlay">
      <div className="loader-logo">
        <span className="loader-ring r1" />
        <span className="loader-ring r2" />
        <span className="loader-ring r3" />
        <img
          src="/logo.png"
          alt=""
          className="loader-logo-img"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      </div>
      <div className="loader-text">
        {text}
        <span className="loader-dots">
          <span />
          <span />
          <span />
        </span>
      </div>
    </div>
  );
}

export default FullScreenLoader;
